var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('div',{staticClass:"um-url"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content )}})]):_c('div',{staticClass:"um-url"},[_vm._v(" 暂无内容 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }